import React, {Component} from "react"
import id from "@irati/utils/id"

import {Product, Deal} from "@irati/types"

import QuantityItem, {QuantityOnChange} from "./QuantityItem"

interface Props {
  handleClick: QuantityOnChange,
  deal: Deal,
  products: Product[]
}

interface State {}

class QuantityContainer extends Component<Props, State> {
  static defaultProps = {
    id: "redeem"
  }

  render() {
    const {handleClick, products, deal} = this.props

    return (
      <div>
        {products.map((item) => (
          <QuantityItem key={item.uuid} id={id(item.name, this.props)} handleClick={handleClick} product={item} deal={deal} />
        ))}
      </div>
    )
  }
}

export default QuantityContainer
